"use client";
import Link from "next/link";
import { motion } from "framer-motion";

export default function Welcome({ cms }: { cms?: Record<string, string> }) {
  return (
    <section className="py-20 px-4 font-nunito">
      <div className="container mx-auto max-w-5xl">
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, margin: "-100px 0px -100px 0px" }}
          transition={{ type: "spring", stiffness: 120, damping: 20 }}
        >
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-school-navy mb-4">
            {cms?.heading /* || "Welcome to" */}
          </h2>
          <h3 className="text-2xl sm:text-3xl md:text-4xl font-light text-school-navy mb-8">
            {cms?.subheading /* || "Ashton John\u2019s Primary & Secondary School!" */}
          </h3>
        </motion.div>
        <div className="text-lg sm:text-xl md:text-2xl text-school-navy space-y-6 mb-8 font-light leading-relaxed">
          <p>
            {cms?.para1 ||
              /* "At Ashton John\u2019s Primary & Secondary School, we are dedicated to empowering our students with knowledge and nurturing their potential through exceptional education. As a coeducational Cambridge International institution in Klerksdorp, we strive to provide high-quality learning experiences that equip our students with the skills necessary to thrive as independent members of society." */
              undefined}
          </p>
          <p>
            {cms?.para2 ||
              /* "Founded in 2021, our school serves students from Grade R through Grade 12, offering the internationally recognised Cambridge curriculum, one of the top five curricula globally. With 4-star boarding facilities about 180km from Johannesburg, we welcome students from across South Africa and internationally." */
              undefined}
          </p>
          <p>
            {cms?.para3 ||
              /* "Our focus on fostering independence, critical thinking, and academic excellence sets the foundation for a bright and successful future for every child who walks through our doors." */
              undefined}
          </p>
        </div>
        <Link
          href="/contact-us"
          className="bg-school-gold hover:bg-school-gold-dark text-black font-bold py-4 px-8 rounded text-base sm:text-lg transition-colors text-center inline-block"
        >
          {cms?.btn_text /* || "CONTACT US" */}
          <span className="sr-only">Contact Ashton John's Private School</span>
        </Link>
      </div>
    </section>
  );
}
